import Vue from 'vue';
import App from '@/App';
import router from '@/router/router';
import store from '@/store/store';
import { DpSentryInit, installTestIdDirective } from '@docupet/component-library';
import i18n from './i18n';
import '@/validate/validate';
import { BootstrapVue } from 'bootstrap-vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { icons } from '@/assets/styles/fontawesome.js';

const env = (process.env?.VUE_APP_ENV || process.env?.NODE_ENV)?.toLowerCase();
if (env !== 'local') {
  DpSentryInit(Vue, 'https://4a31a0feedd14fbb88d41c6b6c6e5731@o452146.ingest.sentry.io/5816154', env);
}

Vue.use(BootstrapVue);
installTestIdDirective(Vue);

library.add(icons);
Vue.component('fa-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

const app = new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');

if (window.Cypress) {
  // only available during E2E tests
  window.app = app;
}
